<template>
    <div class="pagination">
        <a href="" class="prev"></a>
        <a href="" class="cur">1</a>
        <a href="">2</a>
        <a href="">3</a>
        <a href="">4</a>
        <a href="">5</a>
        <a href="">...</a>
        <a href="">51</a>
        <a href="" class="next"></a>
        <span>{{ $t('pagination.jump') }}</span>
        <input type="text" v-model="page">
    </div>
</template>

<script>
export default {
    name: "pagination",
    data() {
        return {
            page: '',
            text:''
        }
    },
    mounted() {

    },
    watch:{

    }
}
</script>

<style scoped lang="scss">
//pagination
.pagination{
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 40px;
    a{
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 10px;
        border-radius: 50%;
        @extend .regular-16px
    }
    a.prev{
        background: url("~@/assets/images/page-l.png") no-repeat center center / 9px auto;
    }
    a.next{
        background: url("~@/assets/images/page-r.png") no-repeat center center / 9px auto;
    }
    a.cur{
        color: #ffffff;
        background-color: $activeColor;
    }
    span{
        margin-left: 30px;
        margin-right: 10px;
        @extend .regular-16px
    }
    input{
        width: 56px;
        height: 24px;
        background: #F7F4F3;
        border-radius: 100px;
        text-align: center;
        @extend .regular-16px;
        border: none;
    }
}

@media only screen and (max-width: 959px) {
    .pagination span,
    .pagination input{
        display: none;
    }
}
</style>
